import React, { useEffect, useRef } from "react";
import "./style.css";

export function Sidebar(props: any) {
  const menuRef = useRef(null);

  function handleOutsideTap(event: TouchEvent) {
    const menu: any = menuRef && menuRef.current;
    if (menu && event.target && !menu.contains(event.target)) {
      props.onClose();
      event.preventDefault();
      event.stopPropagation();
    }
  }

  useEffect(() => {
    document.body.addEventListener("touchend", handleOutsideTap);
    return () => {
      document.body.removeEventListener("touchend", handleOutsideTap);
    };
  });

  return (
    <div className="e-sidebar-overlay">
      <div ref={menuRef} className="e-news-sidebar">
        {props.children}
      </div>
    </div>
  );
}
